import NewFeature from './NewFeature';

export default NewFeature;
